
<template>
    
  <div>
    <div class="app-content content devcontent">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
          <div class="container-fluid">
            <div class="row breadcrumbs-top">
              <div class="col-md-12 content-header-left px-0">
                <h3 class="content-header-title float-left mb-0">
                  Support
                </h3>
                <div class="breadcrumb-wrapper">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/support/tickets"
                        >Tickets</router-link
                      ></li>
                    <li class="breadcrumb-item">Ticket Details</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="content-body">
          <vue-element-loading :active="isLoading" :is-full-screen="true" />
          <section>
            <div class="card">
                <div class="card-header bg-white border-bottom_eee pt-1 px-1 mb-0 common_top_title_searchbgst_dock">
                    <div class="w-auto px-0 mobile-padding-0-2">
                        <div class="avatar bg-light-secondary rounded d-inline-flex mr-1">
                            <div class="avatar-content">
                                <em  class="las la-ticket-alt i_icon_st font-medium-5"></em>
                            </div>
                        </div>
                        <div class="card-title">
                            <span>Ticket Details : </span>
                            <span style="color: blue;">{{details?.ticket_code}}</span>
                        </div>

                        </div>
                    
                </div>
                <div class="row mx-0">
                    <div class="col-lg-4 col-md-6 col-12">
                        <div class="card card-transaction mb-1">
                            <div class="card-body mobile-padding-15-10 px-0">
                                <div class="transaction-item">
                                    <div class="media">
                                        <div class="avatar bg-light-primary rounded">
                                            <div class="avatar-content">
                                                <em class="la-boxes las  font-medium-5"> </em>
                                            </div>
                                        </div>
                                        <div class="media-body">
                                            <h6 class="transaction-title">Department  </h6>
                                            <small>Finance </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-lg-4 col-md-6 col-12">
                        <div class="card card-transaction mb-1">
                            <div class="card-body mobile-padding-15-10 px-0">
                                <div class="transaction-item">
                                    <div class="media">
                                        <div class="avatar bg-light-primary rounded">
                                            <div class="avatar-content">
                                                <em class="la-clipboard-check las  font-medium-5"> </em>
                                            </div>
                                        </div>
                                        <div class="media-body">
                                            <h6 class="transaction-title">Subject </h6>
                                            <small>{{details?.subject}}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-12">
                        <div class="card card-transaction mb-1">
                            <div class="card-body mobile-padding-15-10 px-0">
                                <div class="transaction-item">
                                    <div class="media">
                                        <div class="avatar bg-light-primary rounded">
                                            <div class="avatar-content">
                                                <em class="la-sync-alt las  font-medium-5"> </em>
                                            </div>
                                        </div>
                                        <div class="media-body">
                                            <h6 class="transaction-title">Query/Category Type   </h6>
                                            <small>{{details?.query_name}} </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-12">
                        <div class="card card-transaction mb-1">
                            <div class="card-body mobile-padding-15-10 px-0">
                                <div class="transaction-item">
                                    <div class="media">
                                        <div class="avatar bg-light-primary rounded">
                                            <div class="avatar-content">
                                                <em class="la-file-alt las  font-medium-5"> </em>
                                            </div>
                                        </div>
                                        <div class="media-body">
                                            <h6 class="transaction-title">Description </h6>
                                            <small><span v-html="details?.description"></span></small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-12">
                        <div class="card card-transaction mb-1">
                            <div class="card-body mobile-padding-15-10 px-0">
                                <div class="transaction-item">
                                    <div class="media">
                                        <div class="avatar bg-light-primary rounded">
                                            <div class="avatar-content">
                                                <em class="la-paperclip las  font-medium-5"> </em>
                                            </div>
                                        </div>
                                        <div class="media-body">
                                            <h6 class="transaction-title">Attachments </h6>
                                            <div class="daily_transaction_photos_details">
                                               <ul>
                                                <li> 
                                                    <div class="photo_details_doc_04"  v-if="details?.attachment && details.attachment.length"> 
                                                        <div class="innerphoto_details_doc_04">
                                                            <template v-for="(seal, idx) in details?.attachment">
                                                                <img alt=""  class="" :src="findImageUrl('fileKey', seal.fileKey)" >
                                                            </template>
                                                        </div>
                                                    </div>
                                                    <div class="photo_details_doc_04"  v-else> 
                                                        <!-- <div class="innerphoto_details_doc_04">
                                                            <img alt=""  class="" src="images/icons/noimage.jpg" >
                                                        </div> -->
                                                        <h6 class="vehicle_name_text"> No attachements </h6>
                                                    </div>
                                                </li>
                                               </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 <div class="row mx-0">
                    <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                        <label class="form-label" for="project-name">Ticket Type Status </label>
                            <treeselect class="" placeholder="Status" id=""  :options="status_list"/>
                     </div>
                     <div class="ol-12 col-sm-6 col-md-6 col-lg-4 mb-1 ">
                        <label class="form-label" for="project-name">Assigned To </label>
                            <treeselect class="" placeholder="Assignee" id="" :options="assignee_list" />
                     </div>
                    <div class="col-lg-12 col-md-12 col-12">
                        <div class="form-group ckeditarheightview">
                            <label class="form-label" for="project-name">Comment </label>
                            <ckeditor class="ckeditarheight" :editor="editor" placeholder="Add Comment"  :config="editorConfig" tag-name="textarea" v-model="formData.comment" ></ckeditor>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-right  home_das_all_buttons_style mobileview_b_8 mb-2">
                          <button type="submit" class="btn btn-outline-primary mr-0 waves-effect  " :disabled="!validateForm()" @click="saveData">
                              Submit
                          </button>
                      </div>
                </div>
                 
               
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Quagga from "quagga";
import "vue2-datepicker/index.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Treeselect from "@riophae/vue-treeselect";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import CKEditor from '@ckeditor/ckeditor5-vue2';

import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import VueElementLoading from "vue-element-loading";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import searchMasterNameList from "../../../utils/searchMasterNameList";
import common_methods from "../../../utils/common_methods";
import axios from "axios"


export default {
  name: "TicketDetails",
  mixins: [searchMasterNameList, common_methods],
  data() {
    return {
      isLoading: false,
      department_list: [],
      query_list: [],
      status_list: [
          {
            id: "open",
            label: "Open"
          },
          {
            id: "resolved",
            label: "Resolved"
          },
          {
            id: "closed",
            label: "Closed"
          }
      ],
      assignee_list: [],
      details: null,
      presignedUrls: [],
      formData: {
        comment: "",
      },
      editor: ClassicEditor,
            editorConfig: {
                
               toolbar: {
                height: 300,
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        '|',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'insertTable',
                        '|',
                        'undo',
                        'redo', '|',
                    ],
                },
            },
   
    };
  },
  components: {
    DatePicker,
    Treeselect,
    Loading,
    VueElementLoading,
    VueTimepicker,
    ckeditor: CKEditor.component,
  },
  mounted() {},
  created() {
    let id = this.$route.params?.id
    this.getDetails(id)
    this.getQueryList()
    this.getUsers()
  },
  methods: {
    findImageUrl(tab, key) {
        let presignedUrls = this.presignedUrls
        let urlObj = presignedUrls.find(obj => obj.fileKey === key)
        if(urlObj)  return urlObj.url
        return ""
    },
    getQueryList() {
      this.searchNameMasterList('query_type', 'query_name', null, 'query_id')
        .then(result => {
          this.query_list = result.data
        })
        .catch(e => {
          this.displayError(e)
        })
    },
    getUsers() {
        this.searchNameMasterList('user_master', 'staff_id', null, 'staff_id')
        .then(result => {
          this.assignee_list = result.data.filter(s => !s.label.includes('firstcry'))
        })
        .catch(e => {
          this.displayError(e)
        })
    },
    validateForm() {
        if(!this.formData.comment) {
            return false
        }
        return true
    },
    getDetails(id) {
        // this.isLoading = true
        this.makeRequest("GET", `/support/tickets/${id}`)
            .then(result => {
                this.isLoading = false
                this.details = result.data.data
                this.presignedUrls = result.data.presignedUrls
            })
            .catch(e => {
                this.displayError(e)
            })
    },
    saveData() {
        this.sweetAlertSnackbar("Comment Added Successfully", "success")
        this.formData.comment = ""
    }
  },
};
</script>
<style>
.ckeditarheightview .ck.ck-content{
                height: 150px!important;
            }
            .ck.ck-powered-by{
              display: none!important;
            }
</style>
